import type { Query } from "@tanstack/react-query";

export function shouldDehydrateSsrQuery(query: Query): boolean {
  // Router's DB integration owns collection rows and live-query snapshots.
  // Query collection metadata contains class-based query expressions that
  // Seroval cannot serialize, so its backing requests must not also enter
  // Router's Query stream. Ordinary application queries still hydrate normally.
  return query.meta?.loadSubsetOptions === undefined;
}
